export default __webpack_public_path__ + "static/media/background_image_red.14211f09.png";